import { jsx as _jsx } from "react/jsx-runtime";
import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { analytics } from 'app/utils/segment';
import { ConversationId } from 'components/conversation/conversationId';
export const TableInstrumentConversationId = ({ csid, panel, }) => {
    const { dashboard, meta: { openLinksInNewTab: openInNewTab }, } = useAnalyticsState();
    return (_jsx(ConversationId, { csid: csid, actions: {
            link: {
                openInNewTab,
                onClick: () => {
                    analytics.analyticsConversationPreviewClicked({
                        csid: csid,
                        dashboard: dashboard.title,
                        panel: panel.title,
                    });
                },
            },
            preview: {
                onClick: () => {
                    analytics.analyticsConversationLinkClicked({
                        csid,
                        dashboard: dashboard.title,
                        panel: panel.title,
                    });
                },
            },
        } }));
};
